module.exports = __webpack_public_path__ + "static/media/projects_image.deabd832.svg";